import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, forwardRef, Output, EventEmitter } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { IntlTelInputComponent, intlTelInput } from "intl-tel-input/angularWithUtils";
import type { Iso2 } from "intl-tel-input/angular/build/types/intl-tel-input/data.js";

@Component({
    selector: 'demooz-input-phone',
    templateUrl: './input-phone.component.html',
    styleUrls: ['./input-phone.component.scss'],
    imports: [IonIcon, ReactiveFormsModule, IntlTelInputComponent],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ]
})
export class DemoozInputPhoneComponent implements OnInit {

    @Input({alias : 'label', required : false}) labelInput: string = '';
    @Input({alias : 'fixedLabel', required : false}) fixedLabel: boolean = false;
    @Input({alias : 'icon', required : false}) iconInput: string = '';
    @Input({alias : 'formName', required : true}) formName: string|number = '';
    @Input({alias : 'errorText', required : false}) errorText: string = this.translateService.instant('MAIN.MSG_ERROR_FIELD_MANDATORY');
    @Input({alias : 'disabled', required : false}) disabled: boolean = false;
    @Input({alias : 'autocomplete', required : false}) autocomplete: boolean = false;
    @Input({alias : 'showBtnClearInput', required : false}) showBtnClearInput: boolean = false;
    @Input({alias : 'noMargin', required : false}) noMargin: boolean = false;
    @Input({alias : 'textAlign', required : false}) textAlign: 'left'|'center'|'right' = 'left';
    @Input({alias : 'countries', required : false}) countries: Array<string>;
   
    @ViewChild('demoozInput') demoozInput: IntlTelInputComponent;

    isRequired: boolean = false;
    errorTextNumberValidation: string = this.errorText;
    initOptions: any = {};
    init: boolean = false;
    updateStatusChange: Subscription;

    constructor(
        public translateService: TranslateService,
        public formGroupDirective: FormGroupDirective
    ) {}

    ngOnInit() {       
        this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required); 
        this.updateStatusChange = this.formGroupDirective.form.controls[this.formName].statusChanges.subscribe((s) => {
            this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        });        
    }
    
    async ngOnChanges(changes: SimpleChanges) {   
        if(changes['countries']){
            this.setInitOptions();
        }             
        if(changes['disabled'] && changes['disabled'].currentValue !== null){    
            if(this.disabled === true){
                this.formGroupDirective.form.controls[this.formName].disable({emitEvent: false});
            }
            else{
                this.formGroupDirective.form.controls[this.formName].enable({emitEvent: false});
            }
        }
    }
    
    ngOnDestroy() {           
        if(this.updateStatusChange){
            this.updateStatusChange.unsubscribe();
        }
    }
    
    setInitOptions() {
        if(this.countries.length > 0){
            this.initOptions = {           
                onlyCountries: this.countries.map(c => c.toLowerCase()) as Array<Iso2>,
                initialCountry: this.countries[0].toLowerCase() as Iso2,
                separateDialCode: true,
                formatAsYouType: true,
                formatOnDisplay: true,
                nationalMode: true,
                strictMode: true,
                allowedNumberTypes: ["MOBILE"]
            };    
            this.init = true; 
        }
        else{
            this.initOptions = {};
            this.init = false;
        }
    }
    
    focusInput(){
        if(this.demoozInput){
            this.demoozInput.focus.emit();
        }
    }
            
    clearInput(){
        if(!this.disabled){
            if(this.formGroupDirective.form.controls[this.formName]){
                let value: any = '';                
                this.formGroupDirective.form.controls[this.formName].setValue(value);
            }
        }
    }
    
    onValidityChange(valid: boolean){
        let errorTextNumberValidation = this.errorText;
        if(!valid){
            let iti = this.demoozInput?.getInstance();
            if(iti){
                let error = iti.getValidationError();
                if(error !== 0){
                    errorTextNumberValidation = this.translateService.instant('INPUT_PHONE.MSG_ERROR_FORMAT_NUMBER');
                }
            }        
        }
        this.errorTextNumberValidation = errorTextNumberValidation;
    }
}
